import React, { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import LoginService from "../../Services/login_service";
import "react-toastify/dist/ReactToastify.css";
import "./ForgotResetPassword.css";

function ForgotResetPassword() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const isResetMode = !!token;

  const handleForgotSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await LoginService.forgotPassword(email);
      if (res.success) {
        toast.success("Reset link sent to your email.");
        setEmail("");
      } else {
        toast.error(res.message || "Failed to send reset link.");
      }
    } catch (error) {
      toast.error("Error sending reset link.");
    }
  };

  const handleResetSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      toast.error("Passwords do not match.");
      return;
    }

    try {
      const res = await LoginService.resetPassword(token, password);
      if (res.success) {
        toast.success("Password reset successfully.");
        setTimeout(() => navigate("/login"), 1500);
      } else {
        toast.error(res.message || "Failed to reset password.");
      }
    } catch (error) {
      toast.error("Something went wrong.");
    }
  };

  return (
    <div className="forgot-reset-container">
      <div className="forgot-reset-card">
        <h2 className="forgot-reset-title">Forgot Password</h2>
        {!isResetMode ? (
          <form onSubmit={handleForgotSubmit}>
            <input
              type="email"
              className="forgot-reset-input"
              placeholder="Enter your registered email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <button type="submit" className="forgot-reset-btn">
              Reset Password
            </button>
          </form>
        ) : (
          <form onSubmit={handleResetSubmit}>
            <input
              type="password"
              className="forgot-reset-input"
              placeholder="New Password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <input
              type="password"
              className="forgot-reset-input"
              placeholder="Confirm Password"
              required
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
            <button type="submit" className="forgot-reset-btn">
              Reset Password
            </button>
          </form>
        )}

        <button
          className="back-btn"
          onClick={() => navigate("/login")}
        >
           Back to Login
        </button>
      </div>

      <ToastContainer position="bottom-left" autoClose={4000} theme="colored" />
    </div>
  );
}

export default ForgotResetPassword;
